<template>
  <div class="upload-wrapper" :style="{'--width': width, '--height': height, '--showAdd': showAddBtn}">
    <template v-if="!showFileList">
      <div v-for="(pic, index) in files" :key="index" class="pic-item" >
        <img class="pic-cover" :src="pic.url"/>
        <div class="pic-operate" v-if="!disabled">
          <i class="el-icon-delete"  @click="handleRemoveByCustom(index)"></i>
          <i class="el-icon-zoom-in" @click="handlePictureCardPreview(index)"></i>
        </div>
      </div>
    </template>


    <el-upload
        :disabled="disabled"
        class="upload"
        :list-type="listType"
        :show-file-list="showFileList"
        v-bind="$attrs"
        v-on="$listeners"
        :file-list="files"
        :on-remove="handleRemove"
        :on-success="handleUploadSuccess"
        :on-exceed="handleExceed">
      <template #default>
        <slot>
          <i class="el-icon-plus"/>
        </slot>
      </template>

      <template #tip>
        <slot name="tip"></slot>
      </template>
    </el-upload>



    <!--图片预览容器-->
    <el-image-viewer :append-to-body="true" :z-index="4000" v-if="showViewer" :initial-index="previewIndex" :url-list="picList" :on-close="closeViewer" />
  </div>
</template>

<script>
import props from "@/components/pic-upload/props";
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";

export default {
  name: "PicUpload",
  model: {
    event: "change",
    prop: "value"
  },
  props,
  components: {ElImageViewer},
  data() {
    return {
      files: [],
      // 预览图片初始索引
      previewIndex: 0,
      showViewer: false,
    }
  },
  methods: {
    handlePictureCardPreview(index) {
      this.previewIndex = index;
      this.showViewer = true;
    },

    closeViewer() {
      this.showViewer = false;
    },

    handleRemoveByCustom(index) {
      let file = this.files.splice(index, 1);
      this.handleRemove(file[0], this.files);
    },

    handleRemove(file, fileList) {
      this.onRemove(file, fileList);
      this.files = fileList;
      if (this.manual) return;
      let result;
      if (typeof this.value === "string") result = this.value ? this.value.split(",") : [];
      else result = this.value;
      let delItem = file.url.split("=")[1];
      let delIndex = result.indexOf(delItem);
      result.splice(delIndex, 1);
      if (typeof this.value === "string") {
        this.$emit("change", result.join(","));
      } else {
        this.$emit("change", result);
      }
    },

    handleUploadSuccess(res, file, fileList) {
      this.onSuccess(res, file, fileList);
      if (this.manual) return;
      if (res.status !== 200) {
        this.$message.error(res?.desc || this.$t('上传失败'));
        return;
      }
      // 判断 value 接收类型，字符串以 , 拼接，数组直接赋值
      if (typeof this.value === "string") {
        let result = this.value ? this.value.split(",") : [];
        result.push(res.data.code);
        this.$emit("change", result.join(","));
      } else if (Array.isArray(this.value) && this.value.length) {
        this.$emit("change", [...this.value, res.data.code]);
      } else {
        this.$emit("change", res.data.code);
      }
    },


    handleExceed() {
      // this.$message.warning(`只能上传${this.$attrs?.limit || 1}个文件`);
      this.$message.warning(`${this.$t('只能上传') + this.$attrs?.limit || 1 + this.$t('个文件')}`);
    },
  },
  computed: {
    showAddBtn() {
      const flag = this.fileList.length < (this.$attrs?.limit || 1);
      return flag ? "flex" : "none";
    },

    fileList() {
      // 判断 value 类型
      if (typeof this.value === "string" && this.value) {
        return this.value.split(",").map(item => {
          let url = this.downloadUrl + item;
          if (item.startsWith("http://") || item.startsWith("https://")) url = item;
          return {url}
        })
      } else if (Array.isArray(this.value) && this.value.length) {
        return this.value.map(item => {
          let url = this.downloadUrl + item;
          if (item.startsWith("http://") || item.startsWith("https://")) url = item;
          return {url};
        })
      }
      return [];
    },
    picList() {
      return this.files.map(item => item.url);
    }
  },
  watch: {
    fileList: {
      handler(list) {
        this.files = [...list];
      },
      immediate: true,
    }
  }
}
</script>

<style lang="scss" scoped>

.upload-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.pic-item {
  width: var(--width);
  height: var(--height);
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  &:hover {
    .pic-operate {
      display: flex;
    }
  }

  .pic-operate {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0, 0, 0.4);
    display: none;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    column-gap: 10px;

    .el-icon-delete {
      font-size: 18px;
      color: #ffffff;
    }

    .el-icon-zoom-in {
      font-size: 18px;
      color: #ffffff;
    }
  }

  .pic-cover {
    width: var(--width);
    height: var(--height);
  }
}


.upload {
  //display: flex;
  //flex-wrap: wrap;
}

::v-deep .el-upload--picture-card {
  display: var(--showAdd);
  //display: flex;
  align-items: center;
  justify-content: center;

  width: var(--width);
  height: var(--height);
}

::v-deep .el-upload-list--picture-card {

  li {
    width: var(--width);
    height: var(--height);
  }
}

/* 关闭 el-upload 的进入和移除过渡动画 */
::v-deep .el-upload-list__item {
  transition: none !important;
  -webkit-transition: nonne !important;
}

/* 如果有必要，关闭其他相关过渡效果 */
::v-deep .el-upload--picture-card {
  transition: none !important;
  -webkit-transition: nonne !important;
}

</style>
